// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"UIDwZGncbXuNTUhvfNTu"};